import { beige } from "./beige";
import { blue } from "./blue";
import { gray } from "./gray";
import { green } from "./green";
import { magenta } from "./magenta";
import { orange } from "./orange";
import { providerSearchAccent } from "./providerSearchAccent";
import { purple } from "./purple";
import { red } from "./red";
import { steelBlue } from "./steelBlue";
import { generateForegroundColorObject } from "./utils/contrast";
import { yellow } from "./yellow";

export const white = "#FFF";

export const commonColors = {
  beige: { ...beige, ...generateForegroundColorObject(beige) },
  black: "#000",
  blue: {
    ...blue,
    ...generateForegroundColorObject(blue),
  },
  gray: { ...gray, ...generateForegroundColorObject(gray) },
  green: { ...green, ...generateForegroundColorObject(green) },
  magenta: { ...magenta, ...generateForegroundColorObject(magenta) },
  orange: { ...orange, ...generateForegroundColorObject(orange) },
  providerSearchAccent: {
    ...providerSearchAccent,
    ...generateForegroundColorObject(providerSearchAccent),
  },
  purple: { ...purple, ...generateForegroundColorObject(purple) },
  red: { ...red, ...generateForegroundColorObject(red) },
  steelBlue: {
    ...steelBlue,
    ...generateForegroundColorObject(steelBlue),
  },
  white,
  yellow: { ...yellow, ...generateForegroundColorObject(yellow) },
} as const;
